export default {
  admin_c_p_management: ['admin_c_p_management'],

  vehicle_category_management: ['vehicle_category_management'],
  vehicle_category_add: ['vehicle_category_add'],
  vehicle_category_edit: ['vehicle_category_edit'],
  vehicle_category_delete: ['vehicle_category_delete'],
  vehicle_category_archive: ['vehicle_category_archive'],

  business_management: ['business_management'],
  business_add: ['business_add'],
  business_edit: ['business_edit'],
  business_delete: ['business_delete'],
  business_archive: ['business_archive'],

  task_management: ['task_management'],
  task_add: ['task_add'],
  task_edit: ['task_edit'],
  task_delete: ['task_delete'],
  task_archive: ['task_archive'],

  node_management: ['node_management'],
  node_add: ['node_add'],
  node_edit: ['node_edit'],
  node_delete: ['node_delete'],
  node_archive: ['node_archive'],

  node_type_management: ['node_type_management'],
  node_type_add: ['node_type_add'],
  node_type_edit: ['node_type_edit'],
  node_type_delete: ['node_type_delete'],
  node_type_archive: ['node_type_archive'],

  node_location_management: ['node_location_management'],
  node_location_add: ['node_location_add'],
  node_location_delete: ['node_location_delete'],
  node_location_archive: ['node_location_archive'],
  node_location_edit: ['node_location_edit'],

  workflow_management: ['workflow_management'],
  workflow_add: ['workflow_add'],
  workflow_edit: ['workflow_edit'],
  workflow_delete: ['workflow_delete'],
  workflow_archive: ['workflow_archive']
}
